import React, { forwardRef, useState, useEffect } from 'react'
import { Cascader, Toast } from '@ow/comps'
import { useDitto } from '@ow/ditto-core'

const Render = function ({ opts, onChange, value = [], style = {} }) {
  const { readonly } = opts
  const [areas, setAreas] = useState([])
  const { onFetchRemoteData: onFetchRemoteDataDitto, tbId } = useDitto()

  useEffect(() => {
    if (onFetchRemoteDataDitto) {
      const area = onFetchRemoteDataDitto('area')
      area.fetchEffectiveBindTreeData(tbId).then((data) => {
        setAreas(data)
      })
    }
  }, [])

  return (
    <div className="w-full">
      <Cascader
        selectLeaf
        tree={areas}
        inputStyle={{ width: '100%', height: '36px', ...style }}
        fieldNames={{
          key: 'parentsIdStr',
          label: 'title',
          value: 'parentsIdStr',
          children: 'children',
        }}
        treeNodeLabelProp="parentsNameStr"
        disabled={readonly}
        onChange={(selectedKeys) => {
          if (value && selectedKeys && selectedKeys.length < value.length) {
            onChange([selectedKeys.split('-')])
          } else {
            onChange([])
          }
        }}
        onSelect={(val, node) => {
          if (node.children || node.isParentNode) {
            Toast.error({
              title: '只能选择末级点位',
            })
          } else {
            onChange(val.split('-'))
          }
        }}
        value={value ? value.join('-') : []}
      />
    </div>
  )
}

export default forwardRef(Render)
